import React, { useEffect, useState } from 'react';
import { Alert } from 'react-bootstrap';

const OfflineAlert = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return !isOnline ? (
    <Alert variant="danger" className="p-1 mb-2 text-center">
      Sei offline 💔
    </Alert>
  ) : null;
};

export default OfflineAlert;
